import React from "react";
import { Button } from "react-bootstrap";
import { CardText } from "react-bootstrap-icons";
import { Tooltip, Whisper } from "rsuite";

export default function BreakSynopsis({ text }) {
    const tooltip = (
        <Tooltip arrow={false}>
            <p className="mb-0">{text}</p>
        </Tooltip>
    );

    return (
        <Whisper trigger={"click"} placement="auto" speaker={tooltip} controlId={text?.substring(20, 40)}>
            <Button variant="contained" className="btn-download border-0 p-0" disabled={!text} aria-label="Show synopsis">
                <CardText height={32} width={32} />
            </Button>
        </Whisper>
    );
}
